module.exports = "/_next/static/images/img__card-2-desktop-072f5f1e5f2d22d5540e1050d070229a.png";